module.exports = __webpack_public_path__ + "static/media/big_buck_bunny.f13004e.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/big_buck_bunny.mp4
// module id = 0/F2
// module chunks = 0